import styled from "@emotion/styled";
import { ConfirmationCode } from "@ubnt/ui-components";
import { Text } from "@ubnt/ui-components/aria";

export const MainWrapper = styled.div`
  display: flex;
  padding-top: 128px;
  flex-direction: column;
  align-items: center;
`;

export const Description = styled(Text)`
  margin: 8px 0 46px;
`;

export const StyledConfirmationCode = styled(ConfirmationCode)`
  div:first-of-type {
    display: flex;
    justify-content: center;
  }
`;

export const ApproveButtonSection = styled.div`
  width: 230px;
  margin: 32px auto 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
